import Vue from 'vue';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import store from './index';

Vue.use(VueAxios, Axios);

// Vue.prototype.$http = Axios;
const token = localStorage.getItem('token');
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}

let axiosInstance = Axios.create({
    baseURL: process.env.VUE_APP_API_URL
});

// Request interceptor
axiosInstance.interceptors.request.use(
    request => {
        return request;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor
axiosInstance.interceptors.response.use(
    response => {
        return response
    },
    error => {
        const {status, data} = error.response;
        if (status === 401 && error.config && !error.config.__isRetryRequest) {
            store.dispatch('auth/logout')
        }
        return Promise.reject(error)
    }
);

export default axiosInstance;
